// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/rate","halfWrapperFixed":"rate-m__halfWrapperFixed__3P_cg","labelFixed":"rate-m__labelFixed__h_tSj","iconWrapperFixed":"rate-m__iconWrapperFixed__og4Wb"};